import { BaseGroup, BasePolicy, BaseProfile, BaseUser } from '@lib/core/model';

import { Device } from './device';

export class SearchResult {
  public readonly isEmpty: boolean;

  constructor(
    public readonly users: BaseUser[] = [],
    public readonly devices: Device[] = [],
    public readonly groups: BaseGroup[] = [],
    public readonly policies: BasePolicy[] = [],
    public readonly profiles: BaseProfile[] = []
  ) {
    this.isEmpty =
      this.users.length === 0 &&
      this.devices.length === 0 &&
      this.groups.length === 0 &&
      this.policies.length === 0 &&
      this.profiles.length === 0;
  }
}
